enum ClaimsActivityVolumeLabelEnum {
  Core = "Core",
  Standard = "Standard",
  Peripheral = "Peripheral",
  RxOnly = "RX Only",
  InsufficientData = "Insufficient Data",
  Ghost = "Ghost",
  Total = "Total",
}

export { ClaimsActivityVolumeLabelEnum };